import React, { createRef, useEffect, useState } from "react";
import CustomSearchBar from "../../../components/CustomSearchBar/CustomSearchBar";
import apiUtil from "../../../api/apiUtil";
import Table from "../../../components/Table/Table";
import getToken from "../../getToken";
import api from "../../../api/api";
import "./memberList.css";
import { DateRange } from "react-date-range";
import { format } from "date-fns";
import calenderIcon from "../../../images/icons/calendar.png";
import * as XLSX from "xlsx";
import excelIcon from "../../../images/icons/download.png";
import SelectFilter from "../../../components/SelectFilter/SelectFilter";

const MemberReport = () => {
  const refAddTable = createRef();
  const [keyword, setKeyword] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });

  const [selectedOption, setSelectedOption] = useState(null);

  const [addList, setaddList] = useState({
    isLoading: true,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  let brandId = localStorage.getItem("brandId");
  let branchIdMap = {
    "265f0dff-a30a-11ed-b26e-6045bdd63acb":
      "8cd5fe32-a30a-11ed-b26e-6045bdd63acb",
    "e7615a4c-b9e4-11ee-93ac-902e16958ce1":
      "734d09cf-b9e5-11ee-93ac-902e16958ce1",
    default: "8c3d4a7a-699d-11ee-9653-902e16958ce1",
  };
  let branchId = branchIdMap[brandId] || branchIdMap.default; const [paramReport, setParamReport] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    brandId: brandId,
    branchId: branchId,
    startDate: format(startDate, "yyyy-MM-dd"),
    endDate: format(endDate, "yyyy-MM-dd"),
  });

  const retrieveaddList = async (value = paramReport) => {
    value.sortBy = selectedOption ? selectedOption.value : "";
    value.keyword = keyword ? keyword : "";
    value.startDate = format(startDate, "yyyy-MM-dd");
    value.endDate = format(endDate, "yyyy-MM-dd");

    console.log(value);

    api.post("Admin/GetMemberReport", value, getToken()).then((result) => {
      console.log(result);
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            setaddList({
              isLoading: false,
              limit: response.data.data.rowLimit,
              data:
                response.data.data.data && response.data.data.data.length > 0
                  ? response.data.data.data.map((row, index) => ({
                    ...row,
                    tableNum:
                      (value.currentPage - 1) * value.rowLimit + index + 1,
                  }))
                  : [],
              total: response.data.data.totalRecords,
              page: response.data.data.paging,
            });
            setExcelData(response.data.data.data);
            console.log(response.data.data.data);
          } else {
            setaddList({
              data: [],
              total: 0,
              page: 0,
              limit: 0,
              isLoading: false,
            });
          }
        },
        (error, type) => {
          console.log(error);
        }
      );
    });
  };

  useEffect(() => {
    retrieveaddList();
  }, [paramReport, startDate, endDate, selectedOption]);
  console.log(addList);

  const handleDateRangeChange = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setStartDate(startDate);
    setEndDate(endDate);
    setDateRange({ startDate, endDate });
    retrieveaddList();
  };

  const handleInputClick = () => {
    setShowDatePicker((prevState) => !prevState);
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!e.target.closest(".date-input-container")) {
        setShowDatePicker(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  // Function to handle Excel export
  const fetchAllData = async () => {
    const allData = [];
    let currentPage = 1;

    try {
      while (true) {
        const response = await api.post(
          "Admin/GetMemberReport",
          { ...paramReport, currentPage },
          getToken()
        );
        const { data } = response.data.data.data;
        console.log(data);
        if (response.data && data && data.length > 0) {
          allData.push(...data);
          currentPage++;
        } else {
          break;
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    console.log("Fetched all data:", allData);
    return allData;
  };

  const exportToExcel = async () => {
    try {
      const allData = await fetchAllData();

      console.log("All Data:", allData);

      if (allData.length === 0) {
        console.warn("No data to export");
        return;
      }
      const excelDataFormatted = allData.map((row, index) => ({
        No: index + 1,
        Name: row.name || "Unknown",
        "Member Type": row.memberType || "-",
        "Phone Number": row.phoneNo || "-",
        Email: row.email || "-",
        Address: row.address || "-",
        Point: row.point || "-",
        // Level: row.level || "-",
      }));

      console.log("Excel Data Formatted:", excelDataFormatted);

      const fileName = "MemberReport.xlsx";

      const ws = XLSX.utils.json_to_sheet(excelDataFormatted);
      console.log("Worksheet:", ws);
      ws["!cols"] = [
        { wpx: 30 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        // { wpx: 100 },
      ];
      ws["!cols"].forEach((col) => {
        col.s = { alignment: { horizontal: "left" } };
      });

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "MemberReport");

      console.log("Workbook:", wb);
      XLSX.writeFile(wb, fileName);
    } catch (error) {
      console.error("Error exporting to Excel:", error);
    }
  };

  const options = [
    { value: "", label: "All" },
    { value: "diamond", label: "Diamond" },
    { value: "gold", label: "Gold" },
    { value: "silver", label: "Silver" },
  ];

  return (
    <>
      <div className="Actions space_between">
        <h6 className="title_text mt-2">Member List History</h6>

        <div className="d-flex justify-content-end gap-16 align-items-center">
          {/* Export to Excel */}
          <div>
            <button className="export-button" onClick={exportToExcel}>
              <img src={excelIcon} className="icon" />
              Export to Excel
            </button>
          </div>

          {/* <CustomFilter /> */}
          <SelectFilter
            options={options}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            defaultValue="Level"
          />

          {/* dateRangePicker */}
          <div className="date-input-container ">
            <input
              type="text"
              className="inputBox input-right-side_text "
              value={`${format(dateRange.startDate, "yyyy MMM dd")} - ${format(
                dateRange.endDate,
                "yyyy MMM dd"
              )}`}
              readOnly
              onClick={handleInputClick}
            />
            <img
              src={calenderIcon}
              className="iconDate"
              onClick={handleInputClick}
            />
            {showDatePicker && (
              <div className="input-dateRange">
                <DateRange
                  showDateDisplay={false}
                  ranges={[{ startDate, endDate, key: "selection" }]}
                  onChange={handleDateRangeChange}
                />
              </div>
            )}
          </div>
          <div>
            <CustomSearchBar
              value={keyword}
              setValue={setKeyword}
              onSearch={() => retrieveaddList()}
            />
          </div>
        </div>
      </div>

      <div className="table_container report_table">
        <Table
          ref={refAddTable}
          maxBodyHeight={addList.limit * 80}
          isLoading={addList.isLoading}
          grouping={addList.grouping}
          limit={addList.limit}
          page={addList.page}
          total={addList.total}
          data={addList.data}
          onPageChange={(page) => {
            setParamReport({
              ...paramReport,
              currentPage: page,
            });
          }}
          columns={[
            {
              title: "No",
              render: (row) => {
                return row.tableNum;
              },
              width: "80px",
              align: "center",
            },

            // name
            {
              title: "Name",
              render: (row) => {
                if (row.name == null || row.name == "") {
                  return "Unknown";
                }
                return row.name;
              },
              width: "80px",
            },

            // memberType
            {
              title: "Member Type",
              render: (row) => {
                if (row.memberType == null || row.memberType == "") {
                  return "Unknown";
                }
                return row.memberType;
              },
              width: "120px",
            },

            // phoneNo
            {
              title: "Phone Number",
              field: "phoneNo",
              align: "center",
              width: "120px",
            },

            // email
            {
              title: "Email",
              field: "email",
              width: "80px",
            },

            // address
            {
              title: "Address",
              field: "address",
              width: "80px",
            },

            // point
            {
              title: "Point",
              field: "point",
              align: "center",
              width: "80px",
            },

            // // level
            // {
            //   title: "Level",
            //   field: "level",
            //   align: "center",
            //   width: "80px",
            // }
          ]}
        />
      </div>
    </>
  );
};

export default MemberReport;
